import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/about/page.tsx");
